var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"el-select-dropdown__item",class:{
      selected: _vm.itemSelected,
      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
      hover: _vm.hover,
    },style:({display: _vm.visible ? 'block' : 'none',}),on:{"mouseenter":(event) => this.hoverItem(event),"click":(event) => this.selectOptionClick(event)}},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.currentLabel))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }